import classnames from 'classnames';
import React from 'react';

import styles from './container.module.css';

interface ContainerProps {
  fullWidth?: boolean;
  white?: boolean;
  isMobile?: boolean;
  marginBottom?: number;
  children: React.ReactNode;
  id?: string;
  className?: string;
}

const Container = ({
  children,
  fullWidth = false,
  white = false,
  isMobile = false,
  marginBottom = 10,
  id,
  className,
}: ContainerProps) => {
  if (React.Children.count(children) === 0) return null;
  return (
    <div
      id={id}
      style={{ marginBottom }}
      className={classnames(styles.root, className, {
        [styles.rootMobile]: isMobile,
        [styles.rootWhite]: white,
      })}
    >
      <div
        className={classnames({
          [styles.containerNotFullWidth]: !fullWidth,
          [styles.containerMobile]: isMobile,
          [styles.containerNotWhite]: isMobile && !white && !fullWidth,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default Container;
